/*
 * @Description: 
 * @Version: 
 * @Autor: houchuanfang
 * @Date: 2022-07-27 16:05:44
 * @LastEditTime: 2022-08-02 13:55:20
 */
import http from '../../plugins/utils/http'
let api = '/api'
const skill = {
    // 赛事列表
    matchListApi(params) {
        return http.post(`${api}/app-jycy-hebei/skillsOmpetition/list`, params)
    },
    //根据证件号查询成绩-个人
    getResultByCodeApi(params) {
        return http.get(`${api}/app-jycy-hebei/skillsOmpetition/getResultByCode`, params)
    },
    //赛事活动
    //赛事详情
    getDetailByIdApi(params) {
        return http.get(`${api}/app-jycy-hebei/skillsOmpetition/getDetailById`, params)
    },
    //赛事组别报名
    competitionGroupApplyApi(params) {
        return http.post(`${api}/app-jycy-hebei/skillsOmpetition/competitionGroupApply`, params)
    },
    //查所有人的成绩
    hunanAchievementApi(params) {
        return http.get(`${api}/app-jycy-hebei/skillsOmpetition/resultList`, params)
    },
}
export default skill